'use strict';

var sessionUtility = {
    /**
     * Logic to evaluate service message to determine if session is valid
     * @param action {object}
     * @param redirectFn {function}
     * @param insecurePages {array}
     */
    evaluateRedirectToLoginOnSessionExpiration: function evaluateRedirectToLoginOnSessionExpiration(action, redirectFn) {
        var insecurePages = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        if (!action || typeof redirectFn !== 'function') return;

        var pathsForInsecurePagesRegex = this.getPaths(insecurePages);
        var shouldRedirect = !window.location.pathname.match(pathsForInsecurePagesRegex);

        /* in MY, serviceStatus and serviceMessages are members of paymentMethod (e.g. deviates from standard for ORDER) */
        var _action = action.hasOwnProperty('paymentMethod') ? action.paymentMethod : action;
        var _serviceStatus = _action.hasOwnProperty('serviceStatus') ? _action.serviceStatus : '';
        var _serviceMessages = _action.hasOwnProperty('serviceMessages') ? _action.serviceMessages : '';
        if (Array.isArray(_serviceMessages)) {
            _serviceMessages = _serviceMessages.join(' ');
        }

        var isServiceStatusError = _serviceStatus === 'ERROR';
        var isServiceStatusErrorCode = _serviceStatus.trim() === '21' || _serviceStatus.trim() === '22';
        var tokenRequired = _serviceMessages.indexOf("'token' is required.") > -1 || _serviceMessages.indexOf("'token' is a required parameter.") > -1;
        var invalidToken = _serviceMessages.toLowerCase().indexOf('invalid token') > -1 || _serviceMessages.toLowerCase().indexOf('token has expired') > -1;

        if (shouldRedirect && (isServiceStatusError && tokenRequired || isServiceStatusErrorCode || invalidToken)) {
            redirectFn();
        }
    },

    /**
     * Build the regex of paths that should be excluded from session validation
     *
     * @param {string[]} commonPagePaths
     * @returns {RegExp}
     */
    getPaths: function getPaths() {
        var commonPagePaths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        return new RegExp(commonPagePaths.join('|'));
    }
};

module.exports = sessionUtility;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/sessionUtility.js
// module id = 330
// module chunks = 0